module.exports = __webpack_public_path__ + "img/1504491640.854696d7.jpg";